import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CodeSnippetService extends RestfulService<Models.CodeSnippet> {

  constructor(private restService: RestService) {
    super(Models.CodeSnippet);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('code-snippets');
  }

}
